import Text from "@/components/common/Typography/Text"
import MarkIcon from "@/components/icons/MarkIcon"
import { useIsDesktop } from "@/hooks/app/useIsDesktop"
import { useToursCategories } from "@/hooks/tour/useToursCategories"
import { Button, Col, Image, Row, theme } from "antd"
import { FC } from "react"
import { useTranslation } from "react-i18next"

type DefaultPlacementsProps = {
  onChange?: (valueObject?: any) => void,
}

const DefaultPlacements: FC<DefaultPlacementsProps> = ({ onChange }) => {
  const { data: { searchToursResult }, loading } = useToursCategories()
  const isDesktop = useIsDesktop()
  const { t } = useTranslation()

  if (loading) {
    return (
      <Row justify='center' align='middle' style={{ marginBlock: '2rem' }}>
        <div className="loader" />
      </Row>
    )
  }

  return (
    <Row gutter={0} style={isDesktop ? { padding: 10 }: {}}>
      <Col span={24}>
        <Text strong>
          <MarkIcon /> {t("tour.hot_locations").toUpperCase()}
        </Text>
      </Col>
      {searchToursResult.map(des => {
        const tourCount = (des as any).tourCount || 0
        if (!des.hot) {
          return <></>
        }
        return (
          <Col xs={12} md={8}>
            <Button
              onClick={() => onChange && onChange(des)}
              block
              size='small'
              type='text'
              style={{ maxHeight: 'unset', height: 'auto', justifyContent: 'start', textAlign: 'start', whiteSpace: 'wrap' }}
            >
              <Row style={{ paddingBlock: 12 }} align='middle' gutter={10} wrap={false} justify='start'>
                <Col>
                  <Image
                    style={{ height: "5rem", width: '5rem', objectFit: 'cover' }}
                    preview={false}
                    src={des.images || '/static/images/tour/default_image.png'}
                  />
                </Col>
                <Col flex={1}>
                  <Row justify='start'>
                    <Text>
                      {des.name}
                    </Text>
                  </Row>
                  <Row justify='start'>
                    <Text type='secondary'>
                      {tourCount} Tour{tourCount > 1 ? 's' : ''}
                    </Text>
                  </Row>
                </Col>
              </Row>
            </Button>
          </Col>
        )
      })}
    </Row>
  )
}

export default DefaultPlacements